import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { IncomeReportComponent } from '@frontend/reports/components/income-report.component';
import { PromanAutocompleteComponent } from '@proman/autocomplete/proman-autocomplete.component';
import { PromanColorComponent } from '@proman/color/proman-color.component';
import { PromanWarningComponent } from '@proman/common-components/components/warning.component';
import { PromanCommonComponentsModule } from '@proman/common-components/proman-common-components.module';
import { Fa6Module } from '@proman/fa/fa6.module';
import { SharedDirectivesModule } from '@proman/shared/directives/shared-directives.module';
import { PipesModule } from '@proman/shared/pipes/pipes.module';
import { FlexLayoutModule } from 'ngx-flexible-layout';

import { InputsModule } from '../../inputs/inputs.module';
import { FrontendListManagerModule } from '../../list-manager/frontend-list-manager.module';
import { AccountComponent } from '../../shared/components/account.component';
import { HeaderComponent } from '../../shared/components/header.component';
import { LayoutComponent } from '../../shared/components/layout.component';
import { MenuComponent } from '../../shared/components/menu.component';
import { OverlayMenuComponent } from '../../shared/components/overlay-menu.component';
import { SearchComponent } from '../../shared/components/search.component';
import { ToolBtnsComponent } from '../../shared/components/tool-btns.component';
import { ToolbarComponent } from '../../shared/components/toolbar.component';
import { ToolbarActionsDialogComponent } from '../../shared/components/toolbar-actions-dialog.component';
import { UrlReadDialogComponent } from '../../shared/components/url-read-dialog.component';
import { FrontendDirectivesModule } from '../../shared/frontend-directives.module';
import { FrontendPipesModule } from '../../shared/pipes/frontend-pipes.module';
import { Dialog } from '../../shared/services/dialog.service';
import { SharedComponentsModule } from '../../shared-components/shared-components.module';
import { SharedDialogsModule } from '../../shared-dialogs/shared-dialogs.module';
import { DocsIdDirective } from '../directives/docs-id.directive';

@NgModule({
    imports: [
        CommonModule,
        PipesModule,
        RouterModule,
        InputsModule,
        SharedDirectivesModule,
        PromanCommonComponentsModule,
        SharedComponentsModule,
        SharedDialogsModule,
        MatButtonModule,
        MatChipsModule,
        MatSidenavModule,
        MatToolbarModule,
        MatMenuModule,
        MatDialogModule,
        MatTooltipModule,
        FlexLayoutModule,
        Fa6Module,
        FrontendPipesModule,
        FrontendDirectivesModule,
        PromanColorComponent,
        FrontendListManagerModule,
        PromanAutocompleteComponent,
        PromanWarningComponent,
        IncomeReportComponent,
    ],
    declarations: [
        MenuComponent,
        OverlayMenuComponent,
        ToolbarComponent,
        HeaderComponent,
        SearchComponent,
        AccountComponent,
        ToolBtnsComponent,
        LayoutComponent,
        UrlReadDialogComponent,
        DocsIdDirective,
        ToolbarActionsDialogComponent,
    ],
    providers: [Dialog],
    exports: [
        MenuComponent,
        ToolbarComponent,
        HeaderComponent,
        SearchComponent,
        AccountComponent,
        ToolBtnsComponent,
        LayoutComponent,
        UrlReadDialogComponent,
        ToolbarActionsDialogComponent,
    ],
})
export class MenuModule {}
